"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var snakeEgg = {
    name: "Snake",
    enabled: false,
    trigger: {
        type: "keys",
        keystrokes: ["s", "n", "a", "k", "e"],
    },
    stopTrigger: {
        type: "keys",
        keystrokes: ["Escape"],
    },
    resources: [
        {
            type: "css",
            url: "https://kyco.github.io/eeaas/example-snake.css",
        },
        {
            type: "script",
            url: "https://kyco.github.io/eeaas/example-snake.js",
        },
    ],
    onStart: function () {
        // @ts-expect-error does not exist on window
        window.launchSnake();
    },
    onStop: function () {
        // @ts-expect-error does not exist on window
        window.cleanupSnake();
    },
};
exports.default = snakeEgg;
